/* eslint-disable @typescript-eslint/no-unused-vars */
import { useCallback } from 'react'
import { Handle, Position } from '@xyflow/react'
import edgeLogo from '@/assets/hivemq_Edge_vert.png'

const handleStyleLeft1 = { left: -2, top: 17 }
const handleStyleLeft2 = { left: -2, top: 44 }
const handleStyleLeft3 = { left: -2, top: 70 }

function EdgeNode({ data, isConnectable }) {
  const onChange = useCallback((evt) => {}, [])

  return (
    <div className="custom-node edge-limits">
      <Handle id="a" type="target" position={Position.Left} style={handleStyleLeft1} />
      <Handle id="b" type="target" position={Position.Left} style={handleStyleLeft2} />
      <Handle id="c" type="target" position={Position.Left} style={handleStyleLeft3} />

      <div className="grid grid-cols-3">
        <div className="mr-2">
          <div>
            <b>Modbus</b>
          </div>
          <div>
            <b>MQTT</b>
          </div>
          <div>
            <b>OPCUA</b>
          </div>
          <div>
            <b>Allen-Bradley</b>
          </div>
        </div>
        <div>
          <div>
            <a href={import.meta.env.VITE_EDGE_CC_ADDRESS} target="_blank" rel="noreferrer">
              <img src={edgeLogo} alt="HiveMQ Ent Logo" className="custom-node-edge-logo" />
            </a>
          </div>
        </div>
        <div className="ml-2">
          <div>
            <b>S7</b>
          </div>
          <div>
            <b>UNS</b>
          </div>
          <div>
            <b>Bridge</b>
          </div>
          <div>
            <b>Logs</b>
          </div>
        </div>
      </div>

      <Handle type="source" position={Position.Right} />
    </div>
  )
}

export default EdgeNode
